exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doctorMenu[data-v-145bf41a]{position:relative;display:inline-block;vertical-align:top;width:100%;max-width:720px;padding:25px;background-color:#f9f9f9;border:1px solid #dee2e6;border-radius:6px}.nextButton[data-v-145bf41a]{display:block;width:210px;height:42px;line-height:42px;padding:0;margin:0 auto;color:#fff;font-weight:700;text-align:center;background-color:#cf798a;border:none;border-radius:8px;cursor:pointer}", ""]);

// exports
